(() => {
  // „Neu“-Schild an die echte Bildecke (2026-10-20). fs-studio-chrome.css rechnet die Position aus dem
  // Seitenverhältnis vor und setzt dabei voraus, dass das Bild mittig in der 3:4-Fläche liegt – so legt es
  // Chrome. Auf dem Mac sah der Besitzer das Schild auf Kollektions- und Produktseiten trotzdem zu weit unten,
  // dort liegt das Bild offenbar anders. Darum wird hier gemessen, wo das Bild wirklich liegt. Vom Besitzer
  // freigegeben (Entwurf gezeigt): das Schild ragt 8 px über die obere linke Bildecke, der Großteil liegt auf dem
  // Bild – so sah es vorher auf seiner Startseite aus. Ohne Skript oder vor dem Laden gilt die CSS-Rechnung.
  const inset = -8;
  const known = new WeakSet();

  // Lage im Layout, ohne Transformationen (Hover-Zoom, Scroll-Animation verschieben Bild und Schild gemeinsam)
  const offsetWithin = (element, container) => {
    let top = 0;
    let left = 0;
    let node = element;
    while (node && node !== container) {
      top += node.offsetTop;
      left += node.offsetLeft;
      node = node.offsetParent;
    }
    return node === container ? { top, left } : null;
  };

  const place = badge => {
    const media = badge.closest('.fs-card__media');
    const image = media?.querySelector('.fs-card__visual--primary img');
    if (!image || !image.offsetWidth || !image.offsetHeight) return;
    const offset = offsetWithin(image, media);
    if (!offset) return;
    badge.style.top = `${offset.top + inset}px`;
    badge.style.left = `${offset.left + inset}px`;
  };

  const resize = 'ResizeObserver' in window
    ? new ResizeObserver(entries => {
        for (const entry of entries) {
          const badge = entry.target.closest('.fs-card__media')?.querySelector('.fs-card__badge');
          if (badge) place(badge);
        }
      })
    : null;

  const setup = badge => {
    if (known.has(badge)) return;
    known.add(badge);
    const media = badge.closest('.fs-card__media');
    const image = media?.querySelector('.fs-card__visual--primary img');
    if (!media || !image) return;
    image.addEventListener('load', () => place(badge));
    resize?.observe(media);
    resize?.observe(image);
    place(badge);
  };

  const scan = root => root.querySelectorAll?.('.fs-card__badge').forEach(setup);

  const start = () => {
    scan(document);
    // Karten kommen auch nachträglich (Filter, Karussell, Sektionen im Editor)
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches('.fs-card__badge')) setup(node);
          else scan(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', () => scan(document), { once: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
